import { Checkbox, Label, LabeledControl, Text } from '@zillow/constellation-10';
import { AttachmentIcon, FILE_TYPES } from '@zg-rentals/satellite-components';
import { useContext } from 'react';
import { AppContext } from '../../../../../contexts/AppContextProvider';
import type { HandleSelectAttachmentToDelete } from '../../index';
import { truncatedTextStyles } from '../../../../../styles/text';

type AttachmentCardSelectorProps = {
  fileName: string;
  fileType: string;
  imageSrc: string;
  onSelect: HandleSelectAttachmentToDelete;
  zDocId: string;
};

export default function AttachmentCardSelector({
  fileName,
  fileType,
  imageSrc,
  onSelect,
  zDocId,
}: AttachmentCardSelectorProps) {
  const { isImpersonator } = useContext(AppContext);
  const isZDocPreviewUrl = imageSrc.includes('zillowdocs') && imageSrc?.includes('/image/preview');
  const imageSrcResized = isZDocPreviewUrl ? `${imageSrc}&height=${48}&width=${48}` : imageSrc;
  const isImageFileType = fileType?.includes(FILE_TYPES.IMAGE) ?? false;
  const isVideoFileType = fileType?.includes(FILE_TYPES.VIDEO) ?? false;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSelect(e.target.value, e.target.checked);
  };

  return (
    <LabeledControl
      css={{
        alignItems: 'center',
        // oxlint-disable-next-line constellation/prefer-semantic-tokens -- pre-existing base token; ESLint treated this as warn-level, not blocking
        background: 'gray.100',
        border: '1px solid',
        // oxlint-disable-next-line constellation/prefer-semantic-tokens -- pre-existing base token; ESLint treated this as warn-level, not blocking
        borderColor: 'gray.300',
        borderRadius: 'md',
        display: 'flex',
        marginTop: 'tighter',
        overflowX: 'hidden',
        paddingLeft: 'tighter',
        paddingRight: 'tighter',
        '& input[type="checkbox"]': { marginBlockStart: 0 },
      }}
      control={<Checkbox value={zDocId} onChange={handleChange} css={{ marginBlockStart: 0 }} />}
      label={
        <Label css={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <AttachmentIcon
            isImageFileType={isImageFileType}
            isVideoFileType={isVideoFileType}
            isDisabled={!imageSrc || isImpersonator}
            imageSrc={imageSrcResized}
            alt=""
          />
          <Text
            textStyle="body-sm"
            css={{ ...truncatedTextStyles, maxWidth: '100%', marginLeft: 'default', marginRight: 'default' }}
          >
            {fileName}
          </Text>
        </Label>
      }
    />
  );
}
